module.exports = "/img/dashboard.18cf7c63.png";